import React from 'react';
import {NavLink as Link} from 'react-router-dom';
import Loading from './../misc/Loading';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import EntityField from '../../../contentful/EntityField';
import update from 'immutability-helper';
import _ from 'lodash';
import TagsInput from 'react-tagsinput';

import 'react-tagsinput/react-tagsinput.css';

class StockCar extends React.Component {
  constructor(props) {
    super(props);

    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleTagsChange = this.handleTagsChange.bind(this);
    this.handleAssetChange = this.handleAssetChange.bind(this);
  }

  handleFieldChange(e) {
    const newData = {
      car: {}
    };

    newData.car[e.target.name] = {
      $set: e.target.value
    };

    const props = update(this.props, newData);

    this.props.onChange(props);
  }

  handleAssetChange(name, asset) {
    const event = {
      target: {
        name: name,
        value: asset
      }
    };

    this.handleFieldChange(event);
  }

  handleTagsChange(tagsArray, changed) {
    const newData = {
      car: {}
    };

    // Prevent duplicates on add by checking if its first index is at the end (the newly added one)
    if (tagsArray.includes(changed[0]) && tagsArray.indexOf(changed[0]) !== (tagsArray.length - 1)) {
      return;
    }

    newData.car.tags = {
      $set: tagsArray
    };

    const props = update(this.props, newData);
    this.props.onChange(props);
  }

  handlePublish(e) {
    e.preventDefault();
    this.props.onPublish();
  }

  handleUnpublish(e) {
    e.preventDefault();
    this.props.onUnpublish();
  }

  handleSave(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  render() {
    if (this.props.car && this.props.make) {
      const car = this.props.car;
      // console.log('car', car);
      const makeName = _.capitalize(this.props.make);

      // Handle color
      // If car has override color, use this
      // Else, use the original color from import
      car.color = car.colorOriginal;
      if (car.colorOverride) {
        car.color = car.colorOverride;
      }

      let colorString = null;
      if (car.color) {
        colorString = `${car.color.name} (${car.color.type})`;
      }

      let interiorString = null;
      if (car.interior) {
        interiorString = car.interior.name;
      }

      const fuelMap = {
        Petrol: 'Bensin',
        Diesel: 'Diesel',
        Electric: 'Elektrisk'
      };

      const gearMap = {
        Manual: 'Manuell',
        Automatic: 'Automatisk'
      };

      // Set up variables
      const poweredAxles = (car.variant ? car.variant.poweredAxles : null);
      const engineHorsepower = (car.variant ? car.variant.engineHorsepower : null);
      const gearbox = (car.variant ? gearMap[car.variant.gearbox] : null);
      const variantName = (car.variant ? car.variant.name : null);
      const fuelType = (car.variant ? fuelMap[car.variant.fuelType] : null);
      const variantGroupName = (car.variant ? car.variant.variantGroup.name : null);
      const equipmentLevel = (car.equipmentLevel ? car.equipmentLevel.name : null);

      // Prices
      const variantPrice = (car.variant ? parseInt(car.variant.price, 10) : 0);
      const colorPrice = (car.color ? (car.color.priceAdjustment ? parseInt(car.color.priceAdjustment, 10) : 0) : 0);
      const carAdjustment = (car.priceAdjustment && car.priceAdjustment !== '-' ? parseInt(car.priceAdjustment, 10) : 0);

      const totalPrice = parseInt((variantPrice + colorPrice + carAdjustment), 10);

      return (
        <section className="mf-model mf-padding-top-20">
          <ol className="breadcrumb">
            <li><Link to="/">Forsiden</Link></li>
            <li><Link to="/cars-in-stock/">Biler på lager</Link></li>
            <li>
              <Link to={`/cars-in-stock/${this.props.make}`}>{makeName}</Link>
            </li>
            <li className="active">{car.title}</li>
          </ol>

          <form onSubmit={this.handleSubmit}>
            <div className="page-header">
              <div className="pull-right">
                {this.props.working &&
                  <span>&nbsp;<i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...</span>
                }
                <button
                  type="submit"
                  className="btn btn-default"
                  disabled={!this.props.modified || this.props.working}
                >
                  <span>Lagre endringer</span>
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={(this.props.car.published && !this.props.car.updated) || this.props.working || this.props.modified}
                  onClick={this.handlePublish}
                >
                  <span>Publiser</span>
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-warning"
                  disabled={this.props.car.draft || this.props.working || this.props.modified}
                  onClick={this.handleUnpublish}
                >
                  <span>Avpubliser</span>
                </button>
              </div>
              <h1>
                {car.model.name} <small><em>{car.title}</em></small> <PublishStatusDot entry={this.props.car} />
              </h1>
            </div>

            {/* Display any error message: */}
            {this.props.error &&
              <div className="alert alert-danger">
                {this.props.error}
              </div>
            }

            <div className="last-modified" style={{marginBottom: '20px'}}>
              <h4>Sist importert: <strong>{car.modified}</strong></h4>
              <p className="text-info" style={{marginBottom: '15px'}}>Her finnes info om <strong>biler på lager i Drammen.</strong></p>
            </div>

            <div className="tab-content mf-margin-bottom-40">
              <div className="row">
                <div className="col-xs-12 col-sm-6">
                  <div className="form-group">
                    <label>Prisjustering</label>
                    <input type="text" className="form-control" name="priceAdjustment" defaultValue={car.priceAdjustment} onChange={this.handleFieldChange} />
                  </div>
                  <div className="form-group">
                    <label>Priskalkulering</label>
                    <div className="row">
                      <div className="col-xs-4 col-sm-6">Variantpris</div>
                      <div className="col-xs-4 col-sm-6 col-lg-4 text-right"><strong>{Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(variantPrice)},-</strong></div>
                    </div>
                    <div className="row">
                      <div className="col-xs-4 col-sm-6">Fargetillegg</div>
                      <div className="col-xs-4 col-sm-6 col-lg-4 text-right"><strong>{Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(colorPrice)},-</strong></div>
                    </div>
                    <div className="row">
                      <div className="col-xs-4 col-sm-6">Justering for bil</div>
                      <div className="col-xs-4 col-sm-6 col-lg-4 text-right"><strong>{Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(carAdjustment)},-</strong></div>
                    </div>
                    <div className="row" style={{marginTop: '10px'}}>
                      <div className="col-xs-4 col-sm-6" style={{borderTop: '1px solid #ccc', paddingTop: '10px'}}>
                        Pris til kunde <small className="text-muted">(eksl. fraktpåslag)</small>
                      </div>
                      <div className="col-xs-4 col-sm-6 col-lg-4 text-right" style={{borderTop: '1px solid #ccc', paddingTop: '10px'}}>
                        <strong>{Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(totalPrice)},-</strong>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Tags */}
                <div className="col-xs-12 col-sm-6">
                  <div className="form-group">
                    <label>Tags <em className="small text-muted">Små labels som vises på &quot;kortet&quot; for bil på lager</em></label>
                    <TagsInput
                      addOnBlur={true}
                      value={car.tags}
                      onChange={this.handleTagsChange}
                      className="react-tagsinput form-control"
                      addKeys={[9, 13, 188]}
                      inputProps={{placeholder: 'Legg til'}}
                    />
                  </div>

                  {/* Custom color */}
                  <div className="form-group">
                    <label>Egendefinert farge</label>
                    <EntityField
                      name="colorOverride"
                      contentType="color"
                      value={car.colorOverride}
                      onChange={this.handleAssetChange}
                      disabled={this.props.working || car.archived}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <fieldset>
                  <div className="col-xs-12">
                    <legend>Låste felter</legend>
                  </div>

                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Tittel (modellgruppe fra import)</label>
                      <div className="input-group">
                        <input type="text" className="form-control" name="displayname" defaultValue={car.title} disabled />
                        <div className="input-group-addon">Data fra Axapta</div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Antall</label>
                      <div className="input-group">
                        <input type="text" className="form-control" name="count" defaultValue={car.stock} disabled />
                        <div className="input-group-addon">Data fra Axapta</div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Farge</label>
                      <div className="input-group">
                        <input type="text" className="form-control" name="color" defaultValue={colorString} disabled />
                        <div className="input-group-addon">Data fra Axapta</div>
                      </div>
                    </div>

                    {interiorString && <div className="form-group">
                      <label>Interiør</label>
                      <div className="input-group">
                        <input type="text" className="form-control" name="color" defaultValue={interiorString} disabled />
                        <div className="input-group-addon">Data fra Axapta</div>
                      </div>
                    </div>}

                    <div className="form-group">
                      <label>Hjuldrift</label>
                      <div className="input-group">
                        <input type="text" className="form-control" name="poweredAxles" defaultValue={poweredAxles} disabled />
                        <div className="input-group-addon">Data fra Axapta</div>
                      </div>
                    </div>

                  </div>

                  <div className="col-xs-12 col-md-6">
                    {/* <div className="form-group">
                      <label>Tags</label>
                      <input type="text" className="form-control" name="tags" defaultValue='' />
                    </div> */}

                    <div className="form-group">
                      <label>Variant</label>
                      <div className="input-group">
                        <input type="text" className="form-control" name="variant" defaultValue={variantName} disabled />
                        <div className="input-group-addon">Data fra Axapta</div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Utstyrsnivå</label>
                      <div className="input-group">
                        <input type="text" className="form-control" name="equipmentLevel" defaultValue={equipmentLevel} disabled />
                        <div className="input-group-addon">Data fra Axapta</div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Drivstoff</label>
                      <div className="input-group">
                        <input type="text" className="form-control" name="fuel" defaultValue={fuelType} disabled />
                        <div className="input-group-addon">Data fra Axapta</div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Hestekrefter</label>
                      <div className="input-group">
                        <input type="text" className="form-control" name="engineHorsepower" defaultValue={engineHorsepower} disabled />
                        <div className="input-group-addon">Data fra Axapta</div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Girkasse</label>
                      <div className="input-group">
                        <input type="text" className="form-control" name="gearbox" defaultValue={gearbox} disabled />
                        <div className="input-group-addon">Data fra Axapta</div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xs-12">
                    <div className="form-group">
                      <label>Variantgruppe</label>
                      <div className="input-group">
                        <input type="text" className="form-control" name="variantGroup" defaultValue={variantGroupName} disabled />
                        <div className="input-group-addon">Data fra Axapta</div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>

          </form>
        </section>
      );
    }

    return <Loading title="Bil på lager" text="Laster bildata" />;
  }
}

StockCar.defaultProps = {
  car: null,
  modified: null,
  working: null,
  onChange: () => {},
  onSave: () => {},
  onPublish: () => {},
  onUnpublish: () => {}
};

export default StockCar;
